import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  const navItems = [
    { path: '/', label: t('nav.home') },
    { path: '/about', label: t('nav.about') },
    { path: '/services', label: t('nav.services') },
    { path: '/projects', label: t('nav.projects') },
    { path: '/contact', label: t('nav.contact') }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-logo">EDGE MARINE</h3>
            <p className="footer-description">{t('footer.description')}</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.quickLinks')}</h4>
            <ul className="footer-links">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="footer-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.contact')}</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Mail size={18} />
                <a href="mailto:info@edgegemi.com">info@edgegemi.com</a>
              </li>
              <li className="footer-contact-item">
                <Phone size={18} />
                <a href="tel:+905321368203">+90 532 136 82 03</a>
              </li>
              <li className="footer-contact-item">
                <MapPin size={18} />
                <span>Körfez, Kocaeli, Turkey</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} EDGE MARINE. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
